export default __webpack_public_path__ + "static/media/loading.dc2d0912.gif";